var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('form',{ref:"form",staticClass:"mt-2 lg:m-1 hidden sm:block",attrs:{"action":"/search","method":"GET"}},[_c('vue-autosuggest',{attrs:{"suggestions":_vm.filteredOptions,"input-props":{
            id: 'search-input',
            name: 'query',
            type: 'search',
            class: 'form-control sm:w-48 lg:w-64 ml-1 rounded-full border-2',
            placeholder: 'Search for products, stores, or categories'
        }},on:{"selected":_vm.onSelected},scopedSlots:_vm._u([{key:"default",fn:function(ref){
        var suggestion = ref.suggestion;
return [_vm._v("\n            "+_vm._s(suggestion.item)+"\n        ")]}}]),model:{value:(_vm.query),callback:function ($$v) {_vm.query=$$v},expression:"query"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }